var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_summary",
    transform: "translate(-618 -618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23619",
    "data-name": "Path 23619",
    d: "M0,0H18V18H0Z",
    transform: "translate(618 618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-file",
    transform: "translate(619.638 618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23620",
    "data-name": "Path 23620",
    d: "M26.624,25H11.9V7H24.273l.039,2.313,2.313-.039Z",
    transform: "translate(-11.9 -7)",
    fill: "#f4dc8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23621",
    "data-name": "Path 23621",
    d: "M44,7l2.351,2.274-2.313.039Z",
    transform: "translate(-31.627 -7)",
    fill: "#f3be24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5742",
    "data-name": "Rectangle 5742",
    width: 10.099,
    height: 2.698,
    transform: "translate(2.698 13.452)",
    fill: "#f3be24"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 1.696,
    cy: 1.696,
    r: 1.696,
    transform: "translate(6.051 4.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23622",
    "data-name": "Path 23622",
    d: "M30.236,33.168H24.3A2.969,2.969,0,0,1,27.268,30.2,3.02,3.02,0,0,1,30.236,33.168Z",
    transform: "translate(-19.521 -21.258)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSummary);
export default __webpack_public_path__ + "static/media/user_summary.cca28c37eec6197d5aa01a90fa50ea7e.svg";
export { ForwardRef as ReactComponent };